<template>
    <tr @click="toggleDetail" class="incident-row table-info text-start">
      <td colspan="6">
        <!-- Datos Cloud Vending y Cliente -->
        <div class="row mx-4">
          <div class="col m-0">
            <ul class="list-group list-group-flush m-0">
              <li class="list-group-item" style="background-color: transparent;"><KeyRound /> {{ incident.id }}</li>
              <li class="list-group-item" style="background-color: transparent;"><Store /> {{ incident.expendeduria_name }}</li>
              <li class="list-group-item" style="background-color: transparent;"><Calculator /> {{ incident.maquina_name }}</li>
              <li class="list-group-item" style="background-color: transparent;"><Wrench /> {{ incident.operator_name }}</li>
            </ul>
          </div>
          <div class="col">
            <ul class="list-group list-group-flush m-0">
              <li class="list-group-item" style="background-color: transparent;"><SquareCheck /> <span class="badge rounded-pill" :class="incident.is_resolved ? 'bg-success' : 'bg-danger'"> {{ incident.is_resolved ? 'Resuelto' : 'Pendiente' }}</span></li>
              <li class="list-group-item" style="background-color: transparent;"><CalendarClock /> {{ formatDateTime(incident.incident_date, incident.incident_time) }}</li>
              <li class="list-group-item" style="background-color: transparent;"><CalendarClock /> {{ formatDateTime(incident.resolution_date, incident.resolution_time) }}</li>
            </ul>
          </div>
          <div class="col">
            <ul class="list-group list-group-flush m-0">
              <li class="list-group-item" style="background-color: transparent;"><UserRound /> {{ incident.client_name }}</li>
              <li class="list-group-item" style="background-color: transparent;"><Phone /> {{ incident.client_phone }}</li>
            </ul>
          </div>
        </div>
        <!-- Descripción -->
        <div class="row">
          <div class="incident-details mx-5 mt-3">
            <h5>Descripcion:</h5>
              <!-- <div class="description-text">{{ incident.description }}<</div> -->
              <pre class="description-text">{{ incident.description }}</pre>
          </div>
          
        </div>
      </td>
    </tr>
  </template>
  
  <script setup lang="ts">
  import type { Incident } from '@/types/incidentsTypes';
  import { defineProps } from 'vue';
  import { useIncidentStore } from '@/stores/useIncidentStore';
  import { Wrench, UserRound, Phone, CalendarClock } from 'lucide-vue-next';
  import { Calculator, Store, SquareCheck, KeyRound } from 'lucide-vue-next';
  
  const props = defineProps<{ incident: Incident; }>();
  const store = useIncidentStore();
  
  const toggleDetail = () => {
    store.toggleDetail(props.incident.id);
  };
  
  // Función para formatear la fecha y la hora
  const formatDateTime = (date: string | null | undefined, time: string | null | undefined): string => {
    if (!date) return "N/A";
  
    let formattedDate = new Date(date).toLocaleDateString("es-ES", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    
    let formattedTime = time ? time.slice(0, 5) : "";
  
    return time ? `${formattedDate} ${formattedTime}` : formattedDate;
  };
  
  /* defineEmits(['select']); */
  </script>
  
  <style lang="scss">
  .incident-row {
    cursor: pointer;
    transition: background-color 0.2s;
  
    &:hover {
      background-color: #f8f9fa !important;
    }
  }

  .incident-details {
    //margin-top: 10px;
    //padding: 10px;
    //background-color: #f9f9f9;
    //border: 1px solid #ddd;
    //border-radius: 5px;
    text-align: left;

    /* h5 {
      font-size: 1.1rem;
      font-weight: 600;
      margin-bottom: 8px;
    } */

    h6 {
      font-size: 1rem;
      font-weight: 500;
      margin-top: 10px;
    }

    h5 {
    color: #2c3e50;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
  }

  p, pre {
    &::first-line {
      font-weight: 500;
    }
    
    &:empty::before {
      content: "No hay descripción disponible";
      color: #999;
      font-style: italic;
    }
  }

    pre.description-text {
    white-space: pre-wrap; /* Conserva formato original y hace wrap */
    word-break: break-word; /* Evita overflow horizontal */
    font-family: inherit; /* Mantiene fuente del sistema */
    font-size: 0.9rem;
    background: transparent;
    border: none;
    padding: 0;
    margin: 0;
    line-height: 1.5;
    color: #333;
  }
  }
</style>
  